import { render, staticRenderFns } from "./g-map-data-packaging.vue?vue&type=template&id=8e583be6&scoped=true"
import script from "./g-map-data-packaging.vue?vue&type=script&lang=js"
export * from "./g-map-data-packaging.vue?vue&type=script&lang=js"
import style0 from "./g-map-data-packaging.vue?vue&type=style&index=0&id=8e583be6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e583be6",
  null
  
)

export default component.exports